import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { StrategyDspFunnel } from "@front/m19-api-client";
import { DspFunnelDescriptions } from "@front/m19-models";
import { IBadgeComponent, IIconComponent, ILabelComponent, IRadioComponent, IRadioGroupComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspFunnelIconComponent } from "./dsp-funnel-icon.component";

@Component({
  selector: "app-dsp-funnel-selector",
  template: `<IRadioGroup
    name="dspFunnel"
    *transloco="let t"
    class="flex flex-col gap-2"
    [value]="selectedFunnel()"
    (valueChange)="selectFunnel($event)"
  >
    @for (funnel of funnels; track funnel) {
      <div class="relative">
        @let funnelDescription = FunnelDescriptions[funnel];
        <label
          iLabel
          class="w-full rounded-lg border p-4"
          [for]="funnel"
          [class.disabled]="funnel === StrategyDspFunnel.AWARENESS && disableAwareness()"
          type="card"
        >
          <div class="flex w-full flex-row justify-between">
            <div class="flex items-center gap-4">
              <app-dsp-funnel-icon [funnel]="funnel"></app-dsp-funnel-icon>
              <div>
                <span class="type-body-medium">{{ t(funnelDescription.title) }}</span>
                <p class="text-muted-foreground m-0">{{ t(funnelDescription.description) }}</p>
                <div class="text-muted-foreground mt-1 flex items-center gap-1 select-none">
                  <IIcon name="goal" class="text-main" /><span class="type-label">{{
                    t(funnelDescription.optimizationDescription)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          @if (funnel === StrategyDspFunnel.AWARENESS) {
            <div class="absolute right-4 bottom-4 flex items-center justify-center rounded-lg">
              <IBadge variant="soft" size="sm" [label]="t('common.beta')"></IBadge>
            </div>
          }
          <IRadio [id]="funnel" [value]="funnel" size="lg" class="absolute top-4 right-4" />
        </label>
      </div>
    }
  </IRadioGroup>`,
  imports: [
    TranslocoDirective,
    IIconComponent,
    IBadgeComponent,
    DspFunnelIconComponent,
    IRadioGroupComponent,
    IRadioComponent,
    ILabelComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspFunnelSelectorComponent {
  readonly selectedFunnel = model<StrategyDspFunnel | undefined>(undefined);
  readonly disableAwareness = input<boolean>(false);

  readonly StrategyDspFunnel = StrategyDspFunnel;
  readonly funnels: StrategyDspFunnel[] = [
    StrategyDspFunnel.AWARENESS,
    StrategyDspFunnel.CONSIDERATION,
    StrategyDspFunnel.CONVERSION,
  ];
  readonly FunnelDescriptions = DspFunnelDescriptions;

  selectFunnel(funnel?: StrategyDspFunnel) {
    if (!funnel || this.selectedFunnel() === funnel) {
      return;
    }
    this.selectedFunnel.set(funnel);
  }
}
